import { useNavigate } from 'react-router-dom';

export default function ProductsPreview() {
  const navigate = useNavigate();

  const handleNavigateToProducts = () => {
    navigate('/products');
  };

  const products = [
    {
      title: "High-Quality Protein Feed",
      description: "Premium BSF larvae meal for livestock, poultry, and aquaculture with superior nutritional value and digestibility.",
      features: ["40-45% Protein Content", "Rich in Essential Amino Acids", "Sustainable Alternative", "Cost-Effective"],
      icon: "ri-leaf-line",
      image: "https://public.readdy.ai/ai/img_res/5495fe4e75be4b0b5d7a940bc8bae488.jpg"
    },
    {
      title: "Organic Fertilizer",
      description: "Nutrient-rich BSF frass fertilizer that enhances soil health and promotes sustainable crop production.",
      features: ["100% Organic", "Slow-Release Nutrients", "Improves Soil Structure", "Eco-Friendly"],
      icon: "ri-plant-line",
      image: "https://readdy.ai/api/search-image?query=Organic%20BSF%20frass%20fertilizer%20in%20bags%20and%20application%20on%20crops%2C%20healthy%20green%20plants%20growing%20with%20organic%20fertilizer%2C%20sustainable%20agriculture%2C%20soil%20improvement%2C%20African%20farming%20context&width=300&height=200&seq=organic-fertilizer&orientation=landscape"
    },
    {
      title: "Training & Consultancy",
      description: "Comprehensive BSF farming training programs and consultancy services to empower farmers and entrepreneurs.",
      features: ["Hands-on Training", "Farm Setup Support", "Business Development", "Ongoing Mentorship"],
      icon: "ri-graduation-cap-line",
      image: "https://readdy.ai/api/search-image?query=BSF%20farming%20training%20session%20with%20African%20farmers%20learning%20sustainable%20agriculture%20techniques%2C%20hands-on%20workshop%20in%20modern%20training%20facility%2C%20agricultural%20education%20and%20capacity%20building&width=300&height=200&seq=training-consultancy&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Products & Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From premium BSF larvae to comprehensive training programs, we offer complete solutions for sustainable protein production
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {products.map((product, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 overflow-hidden">
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <i className={`${product.icon} text-2xl text-green-600 mr-3`}></i>
                  <h3 className="text-xl font-bold text-gray-900">{product.title}</h3>
                </div>
                
                <p className="text-gray-600 mb-4 text-sm">
                  {product.description}
                </p>
                
                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  onClick={handleNavigateToProducts}
                  className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button 
            onClick={handleNavigateToProducts}
            className="bg-gray-900 hover:bg-gray-800 text-white py-3 px-8 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
          >
            View All Products & Services
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
